import { render } from "./Streamers.vue?vue&type=template&id=1bdc783a&scoped=true"
import script from "./Streamers.vue?vue&type=script&lang=js"
export * from "./Streamers.vue?vue&type=script&lang=js"

import "./Streamers.vue?vue&type=style&index=0&id=1bdc783a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdc783a"]])

export default __exports__